import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { SERVICE_STATUS_TYPE } from '../../../../util/constant';
import { loggedInUser } from '../../../../store/reducers/account_reducer';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../../../../util/helper';
import { Link } from 'react-router-dom';
import { setBreadCrumb } from '../../../../store/reducers/menu_reducer';
import { factoryId } from '../../../../store/reducers/account_reducer';
import { getUpcomingRemainders } from '../../../../services/vm/apiController';

const UpcomingRemainder = () => {
  const [list, setList] = useState(null);
  let user = useSelector(loggedInUser);
  const dispatch = useDispatch();
  const factoryId_ = useSelector(factoryId);

  useEffect(() => {
    getAUpcoming();
  }, [factoryId_]);

  const getAUpcoming = async () => {
    const upcomingRemainder = await getUpcomingRemainders();
    setList(upcomingRemainder.data);
  };

  useEffect(() => {
    if (user && user.factoryId) {
      axios
        .get(`/installation/getDues`, {
          params: {
            status: SERVICE_STATUS_TYPE.PENDING,
            days: 30,
            factoryId: (user && user.factoryId) || null,
          },
        })
        .then((resp) => {
          setList(resp && resp.data && resp.data.data);
        })
        .catch((error) => {
          setList(null);
        });
    }
  }, [user]);

  const breadCrumbChanges = (id) => {
    dispatch(
      setBreadCrumb({
        label: 'Installation Detail',
        value: `/installations/${id}`,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="header-title">Upcoming Remainders</div>
      <div className="card">
        <div className="card-body p-0">
          {(!list || list.length === 0) && (
            <div className="alert alert-warning mb-0" role="alert">
              <strong>No data available</strong>
            </div>
          )}
          {list && list.length > 0 && (
            <div className="table-responsive">
              <table className="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Vehicle Name</th>
                    <th>Registration Number #</th>
                    <th>Service Info</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.runningVehicleName}</td>
                        <td>
                          <Link to={`/vm/running-vehicle/${item?.OnroadVehicle?.id}/?activeTab=remainder`}>
                            <span onClick={() => breadCrumbChanges(item.id)}>{item?.OnroadVehicle?.registrationNumber}</span>
                          </Link>
                        </td>
                        <td>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item p-0">
                              <p className="mb-0">{item.serviceName}</p>
                              <p className="mb-0">{item.description}</p>
                              <p className="mb-0">{formatDate(item.dueDate)}</p>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {/* <pre>{JSON.stringify(list, null, 4)}</pre> */}
    </React.Fragment>
  );
};

export default UpcomingRemainder;
